/**
 * Adds a function to the SwymCallbacks queue to be exectued once swym is loaded on the page.
 */
const triggerWishlistRequest = (fn) => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(fn);
};

/**
 * Adds a setting to the wishlist.
 */
export const addToWishList = (product) =>
  new Promise((resolve, reject) => {
    triggerWishlistRequest(() =>
      window._swat.addToWishList(
        product,
        (response) => {
          resolve(response);
        },
        (error) => {
          window.console.log({error});
          reject(error);
        },
      ),
    );
  });

/**
 * Removes a setting from the wishlist.
 */
export const removeFromWishList = (product) =>
  new Promise((resolve, reject) => {
    triggerWishlistRequest(() =>
      window._swat.removeFromWishList(
        product,
        (response) => {
          resolve(response);
        },
        (error) => {
          window.console.log({error});
          reject(error);
        },
      ),
    );
  });

/**
 * Fetches all setting wishlist items from the main list.
 * We fetch all wishlist items and filter out setting only based checking if they have the cprops.stock_no property.
 */
export const fetchItems = () =>
  new Promise((resolve) =>
    triggerWishlistRequest(() =>
      window._swat.fetch((items) => resolve(items.filter((wishlistItem) => !wishlistItem?.cprops?.stock_no))),
    ),
  );
